import React, { useState, useEffect } from "react";
import { Container, Row, Card, Col } from "react-bootstrap";
import FirstImage from "../../components/productcomponents/FirstImage";
import Breadcrumb from "../../components/breadcrumbcomponents/Breadcrumb";
import Loader from "../../components/loaderspinnercomponents/Loader";
import axios from "axios";
import { BLOG_API } from "../../config/config";
import imageBorder from "../../assets/images/bestsellerborder.webp";
import { useNavigate } from "react-router-dom";

export const CustmerReview = () => {
    const [BlogBenner, setBlogBenner] = useState([]);
    const [Blogreview, setBlogreview] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [visibleCount, setVisibleCount] = useState(6); // Initial visible items

    const fetchBlogData = async (page) => {
        setLoading(true);
        try {
            const response = await axios.post(BLOG_API, {
                page,
            });
            if (response.data.DATA) {
                setBlogBenner(response.data.DATA[0].data[0].image);
                setBlogreview(response.data.DATA[4].data);
            } else {
                console.error("Unexpected API response structure:", response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    };

    useEffect(() => {
        fetchBlogData(currentPage);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [currentPage]);

    const visibleReviews = Blogreview.slice(0, visibleCount);
    const showViewMore = visibleCount < Blogreview.length;

    return (
        <>
            {loading ? (
                <div className="d-flex justify-content-center align-items-center vh-100">
                    <Loader />
                </div>
            ) : (
                <>
                    <FirstImage image={BlogBenner} />
                    <Breadcrumb
                        breadcrumbTitle="Customer Reviews"
                        breadcrumbNav={[
                            {
                                navText: "Home",
                                path: "/",
                            },
                        ]}
                    />
                    <Container className="pagemargin mb-5">
                        <Row>
                            <div className="text-center customer-rvw-h1 saree-heading pt-2">
                                Customer Reviews
                            </div>
                            <div className="d-flex justify-content-center">
                                <img
                                    src={imageBorder}
                                    className="py-2 border-image"
                                    alt="border"
                                    loading="lazy"
                                />
                            </div>
                            <div className="text-center fs-6 mb-3">
                                Our team has helped 10,000+ entrepreneurs launch their
                                businesses worldwide. As a full-service company, we guide and
                                support our customers. Furthermore, we are committed to
                                empowering women, which is why we also support their
                                development.
                            </div>

                            {/* Render Cards */}
                            {visibleReviews.map((review, index) => (
                                <Col md={4} sm={6} key={index} className="mb-4">
                                    <Card className="p-3 theme-shadow rounded-5 border border-dark them-font h-100">
                                        <div className="d-flex">
                                            <img
                                                src={review.profile_image}
                                                className="img-fluid rounded-circle"
                                                style={{
                                                    width: "90px",
                                                    height: "90px",
                                                    objectFit: "fill",
                                                }}
                                                alt="Avatar"
                                                loading="lazy"
                                            />
                                            <div className="p-2 d-flex flex-column justify-content-center">
                                                <Card.Title>{review.username}</Card.Title>
                                                <Card.Text className="fs-11">
                                                    {review.state_name}
                                                </Card.Text>
                                            </div>
                                        </div>
                                        <hr />
                                        <Card.Text
                                            style={{
                                                height: "100px",
                                                overflow: "scroll",
                                                scrollbarWidth: "none",
                                            }}
                                        >
                                            {review.description}
                                        </Card.Text>
                                    </Card>
                                </Col>
                            ))}

                            {/* View More / Show Less Button */}
                            <div className="text-center mt-3">
                                {showViewMore ? (
                                    <button
                                        className="btn-red-to-black-color-move rounded-4"
                                        onClick={() => setVisibleCount((prev) => prev + 6)}
                                    >
                                        <span>View More</span>
                                    </button>
                                ) : (
                                    Blogreview.length > 6 && (
                                        <button
                                            className="btn-red-to-black-color-move rounded-4"
                                            onClick={() => setVisibleCount(6)}
                                        >
                                            <span>Show Less</span>
                                        </button>
                                    )
                                )}
                            </div>
                        </Row>
                    </Container>
                </>
            )}
        </>
    );
};
